import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
import parseWorkbookMetaStyles from '@industriousapps/excelkits-core/dist/umd/workbookMetaParse';
import BadRequestApiError from '@/interfaces/errors/badRequest';
import UnauthorizedApiError from '@/interfaces/errors/unauthorized';
import NotFoundApiError from '@/interfaces/errors/notFound';
import storageConfig from '@/config/storage';
import hyperFormulaService from '@/services/hyperFormula';
import { encodeSSFArgument } from '@/utils/templateEngine';
import { coreErrorToUserError } from '@/utils/spreadsheets/parseErrors';
import { deleteNotTruthey } from '@/utils/objects';
import { toDigest } from '@/utils/crypto';
import api from '@/services/api/workbooks';
import errorsUtil from '../errors';
import { getFileRequest, subscribeFileRequest, unSubscribeFileRequest } from '@/services/googleDrive';
const PREFIX = 'components: Editor: hooks: useWorkbook:';
const MAX_FILE_SIZE = storageConfig.maxWorkbookSourceFileSizeBytes;
export default (_ref => {
  var _widget$workbook;

  let {
    widget,
    workbookSrc,
    workbookName = '',
    fileOriginSrc = {},
    // NOTE: avoid default values
    workbookFormatsSrc,
    workbookGridsSrc,
    workbookStylesSrc,
    workbookCellDataSrc,
    sheetNamesSrc,
    workbookUpdatedAt: srcWorkbookUpdatedAt = -1 // Negative assumes up to date

  } = _ref;
  const {
    0: activeSpreadsheet,
    1: setActiveSpreadsheet
  } = useState(0);
  const {
    0: initialWorkbook,
    1: setOriginWorkbook
  } = useState(workbookSrc);
  const {
    0: originWorkbookMeta,
    1: setOriginWorkbookMeta
  } = useState({
    sheetNames: sheetNamesSrc || [],
    formats: workbookFormatsSrc,
    grids: workbookGridsSrc,
    styles: workbookStylesSrc,
    cellData: workbookCellDataSrc
  });
  const {
    1:
    /*originWorkbookFileOrigin*/
    setOriginWorkbookFileOrigin
  } = useState(fileOriginSrc);
  const {
    0: workbookId,
    1: setWorkbookId
  } = useState((widget === null || widget === void 0 ? void 0 : (_widget$workbook = widget.workbook) === null || _widget$workbook === void 0 ? void 0 : _widget$workbook.id) || '');
  const {
    0: name,
    1: setName
  } = useState(workbookName);
  const {
    0: sheetNames,
    1: setSheetNames
  } = useState(cloneDeep(sheetNamesSrc || []));
  const {
    0: grids,
    1: setGrids
  } = useState(cloneDeep(workbookGridsSrc));
  const {
    0: styles,
    1: setStyles
  } = useState(cloneDeep(workbookStylesSrc));
  const {
    0: cellData,
    1: setCellData
  } = useState(cloneDeep(workbookCellDataSrc));
  const {
    0: workbook,
    1: setWorkbook
  } = useState(cloneDeep(workbookSrc)); // Set File Origin States

  const {
    0: origin,
    1: setOrigin
  } = useState(fileOriginSrc.origin || '');
  const {
    0: originFileType,
    1: setOriginFileType
  } = useState(fileOriginSrc.originFileType || '');
  const {
    0: originFileId,
    1: setOriginFileId
  } = useState(fileOriginSrc.originFileId || '');
  const {
    0: originUserId,
    1: setOriginUserId
  } = useState(fileOriginSrc.originUserId || '');
  const fileOrigin = useMemo(() => ({
    origin,
    originFileType,
    originFileId,
    originUserId
  }), [origin, originFileType, originFileId, originUserId]);
  const {
    0: formats,
    1: setFormats
  } = useState(cloneDeep(workbookFormatsSrc));
  const {
    0: workbookUpdatedAt,
    1: setWorkbookUpdatedAt
  } = useState(srcWorkbookUpdatedAt); // Workbook errors

  const {
    0: errors,
    1: setErrors
  } = useState([]); // Active spreadsheet errors

  const {
    0: isLoading,
    1: setIsLoading
  } = useState(false); // TODO: needs to continuously deep compare to original state

  const hasWorkbookUpdates = useMemo(() => {
    return !isEqual(initialWorkbook, workbook);
  }, [initialWorkbook, workbook]);
  const hasWorkbookMetaUpdates = useMemo(() => !isEqual(workbookName, name) || !isEqual(originWorkbookMeta.formats, formats) || !isEqual(originWorkbookMeta.sheetNames, sheetNames) || !isEqual(originWorkbookMeta.grids, grids) || !isEqual(originWorkbookMeta.styles, styles) || !isEqual(originWorkbookMeta.cellData, cellData), [workbookName, originWorkbookMeta, name, formats, sheetNames, grids, styles, cellData]);
  const hasUpdates = useMemo(() => hasWorkbookUpdates || hasWorkbookMetaUpdates, [hasWorkbookUpdates, hasWorkbookMetaUpdates]); // Used to detect changes in workbook data

  const {
    0: workbookDataDigest,
    1: setWorkbookDataDigest
  } = useState(''); // Update local state when
  // source workbook data changes
  // NOTE: used primarily for drive sync changes

  useEffect(() => {
    toDigest(JSON.stringify(workbookSrc)).then(newDigest => {
      setWorkbookDataDigest(newDigest); // Abandon update if initial render
      // or there are no data differences

      if (!workbookDataDigest || workbookDataDigest === newDigest) return;
      setWorkbook(cloneDeep(workbookSrc));
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workbookSrc]); // Update local state when
  // source meta changes

  useEffect(() => {
    setOriginWorkbookMeta({
      sheetNames: sheetNamesSrc || [],
      formats: workbookFormatsSrc,
      grids: workbookGridsSrc,
      styles: workbookStylesSrc,
      cellData: workbookCellDataSrc
    });
    setCellData(cloneDeep(workbookCellDataSrc));
    setGrids(cloneDeep(workbookGridsSrc));
    setStyles(cloneDeep(workbookStylesSrc));
    setSheetNames(cloneDeep(sheetNamesSrc || []));
    setFormats(cloneDeep(workbookFormatsSrc));
  }, [sheetNamesSrc, workbookCellDataSrc, workbookFormatsSrc, workbookGridsSrc, workbookStylesSrc]); // Assemble workbook meta data from local state

  const workbookMeta = useMemo(() => ({
    sheetNames,
    formats,
    grids,
    styles,
    cellData
  }), [sheetNames, formats, grids, styles, cellData]); // Assemble errors on workbook update

  useEffect(() => {
    hyperFormulaService.load().then(() => {
      setErrors([...hyperFormulaService.workbookToSpreadsheetErrors(workbook, sheetNames)]);
    });
  }, [workbook, sheetNames, setErrors]); // Grid layout settings (customized column/row demensions)
  // TODO: set inital grid state from storage #564
  // TODO: make a memo that update from active sheet index
  //       and pull data from meta file

  const {
    0: activeSheetGrid
    /*, setActiveSheetGrid*/

  } = useState({}); // Determine if the widget's unique worbook
  // has been published with the latest source
  // workbook data, if not widget needs to be
  // re-published with the latest source workbook

  const isWidgetWorkbookUpToDate = useMemo(() => widget.publishedAt > workbookUpdatedAt, [widget.publishedAt, workbookUpdatedAt]); // Clear errors for
  // each sheet in workbook

  const resetErrors = useCallback(() => {
    setErrors([]);
  }, [setErrors]); // Replace in-memory state with latest data
  // NOTE: this changes the publishable payload

  const localSave = useCallback((wb, meta, name, originData) => {
    if (wb) setWorkbook([...wb]);
    if (meta && meta.sheetNames) setSheetNames([...meta.sheetNames]);
    if (meta && meta.formats) setFormats([...meta.formats]);
    if (meta && meta.grids) setGrids([...meta.grids]);
    if (meta && meta.styles) setStyles(_objectSpread({}, meta.styles));
    if (meta && meta.cellData) setCellData([...meta.cellData]);
    if (name) setName(name);

    if (originData) {
      setOrigin(originData !== null && originData !== void 0 && originData.origin || (originData === null || originData === void 0 ? void 0 : originData.origin) === null ? originData === null || originData === void 0 ? void 0 : originData.origin : '');
      setOriginFileType(originData !== null && originData !== void 0 && originData.originFileType || (originData === null || originData === void 0 ? void 0 : originData.originFileType) === null ? originData === null || originData === void 0 ? void 0 : originData.originFileType : '');
      setOriginFileId(originData !== null && originData !== void 0 && originData.originFileId || (originData === null || originData === void 0 ? void 0 : originData.originFileId) === null ? originData === null || originData === void 0 ? void 0 : originData.originFileId : '');
      setOriginUserId(originData !== null && originData !== void 0 && originData.originUserId || (originData === null || originData === void 0 ? void 0 : originData.originUserId) === null ? originData === null || originData === void 0 ? void 0 : originData.originUserId : '');
    }
  }, [setWorkbook, setFormats, setSheetNames, setGrids, setStyles, setCellData, setOrigin, setOriginFileType, setOriginFileId, setOriginUserId]); // Change active spreadsheet

  const selectSpreadsheet = useCallback(sheetIndex => {
    setActiveSpreadsheet(sheetIndex);
  }, []); // Read file content and parse
  // it into a workbook and its'
  // meta data (ie formats, sheetnames)
  // TODO: resolve errors/warnings (styles not supported for non-xlsx files)

  const upload = async (file, originData, subscriptionActive) => {
    const result = {
      warnings: []
    };
    const fileName = file.name;

    if (file.size > MAX_FILE_SIZE && !subscriptionActive) {
      throw errorsUtil.createFileTooBigError(`${PREFIX} upload:`, fileName);
    }

    let workbookBuffer;
    setIsLoading(true);

    try {
      workbookBuffer = await file.arrayBuffer();
    } catch (err) {
      setIsLoading(false);
      throw errorsUtil.createReadFileError(`${PREFIX} upload:`, err, fileName);
    } // Load Exceljs browser implementation


    let ExcelJs;

    try {
      ExcelJs = await import('exceljs/dist/es5/exceljs.browser');
    } catch (err) {
      result.warnings.push(errorsUtil.createStyleReadError(`${PREFIX} upload: Exceljs download failed`, err, fileName));
    }

    let grids = [];
    let styleCellData = [];

    if (ExcelJs) {
      try {
        const exceljsXlsx = new ExcelJs.Workbook().xlsx;
        const parsedStyles = await parseWorkbookMetaStyles(exceljsXlsx, workbookBuffer, PREFIX);
        if (parsedStyles.grids) grids = parsedStyles.grids;
        if (parsedStyles.cellData) styleCellData = parsedStyles.cellData;

        if (parsedStyles.warnings.length) {
          result.warnings.push(...parsedStyles.warnings.map(err => coreErrorToUserError(PREFIX, err)));
        }
      } catch (err) {
        result.warnings.push(errorsUtil.createStyleReadError(`${PREFIX} upload:`, err, fileName));
      }
    } // Download Core Parsing utils


    let xlsxRead;

    try {
      const xlsx = await spreadsheetCore.loadGlobalXlsx();
      xlsxRead = xlsx.read;
    } catch (err) {
      setIsLoading(false);
      throw errorsUtil.createParseFileError(`${PREFIX} upload: failed to download xlsx dependency:`, err, fileName);
    }

    try {
      const result = spreadsheetCore.parseWorkbook({
        file: workbookBuffer,
        xlsxRead
      }); // Completely replace entire workbook

      setWorkbook(result.workbook);
      setName(fileName);
      setSheetNames(result.meta.sheetNames);
      setFormats(encodeWorkbookFormats(result.meta.formats));
      resetErrors();
    } catch (err) {
      setIsLoading(false);
      throw errorsUtil.createParseFileError(`${PREFIX} upload:`, err, fileName);
    } // Replace or update old style/meta data
    // now that data has been successfully parsed


    setGrids(grids);
    setCellData(styleCellData);
    setStyles({}); // Reset (not used by uploads only local user updates)
    // Set any file origin data

    setOrigin((originData === null || originData === void 0 ? void 0 : originData.origin) || null);
    setOriginFileType((originData === null || originData === void 0 ? void 0 : originData.originFileType) || file.type || null);
    setOriginFileId((originData === null || originData === void 0 ? void 0 : originData.originFileId) || null);
    setOriginUserId((originData === null || originData === void 0 ? void 0 : originData.originUserId) || null);
    setIsLoading(false);
    return result;
  }; // Completely replace entire workbook


  const replace = (workbookData, workbookMeta, workbook) => {
    if (workbook) {
      setName(workbook.name || '');
      setWorkbookId(workbook.id || ''); // replace origin data

      const workbookOrigin = {
        origin: (workbook === null || workbook === void 0 ? void 0 : workbook.origin) || '',
        originFileType: (workbook === null || workbook === void 0 ? void 0 : workbook.originFileType) || '',
        originFileId: (workbook === null || workbook === void 0 ? void 0 : workbook.originFileId) || '',
        //@ts-ignore
        originUserId: (workbook === null || workbook === void 0 ? void 0 : workbook.originUserId) || ''
      };
      setOriginWorkbookFileOrigin(workbookOrigin);
      setOrigin(workbookOrigin.origin);
      setOriginFileType(workbookOrigin.originFileType);
      setOriginFileId(workbookOrigin.originFileId);
      setOriginUserId(workbookOrigin.originUserId);
    } // replace workbook data


    setWorkbook(cloneDeep(workbookData)); // replace workbook meta data

    if (workbookMeta) {
      setOriginWorkbookMeta({
        sheetNames: workbookMeta.sheetNames || [],
        formats: workbookMeta.formats,
        grids: workbookMeta.grids,
        styles: workbookMeta.styles,
        cellData: workbookMeta.cellData
      });
      setGrids(cloneDeep(workbookMeta.grids));
      setStyles(cloneDeep(workbookMeta.styles));
      setCellData(cloneDeep(workbookMeta.cellData));
      setSheetNames(cloneDeep(workbookMeta.sheetNames || []));
      setFormats(encodeWorkbookFormats(workbookMeta.formats));
    } // Reset workbook state


    setWorkbookUpdatedAt(-1);
    setActiveSpreadsheet(0);
    setIsLoading(false);
    resetErrors();
  }; // Send a new workbook to the API
  // for a widget that doesn't have
  // one or update an existing workbook
  //
  // NOTE: this saves a workbook associated with
  // widget, that is what's used by the editor, not
  // by widget's published snippet which consumes a
  // workbook file unique/specific to the widget. That
  // file is explicitly copied over serverside during
  // a widget save/publish.


  const save = async function (config) {
    let targetWorkbookId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let request;
    const widgetId = config.widget.id && config.widget.id !== 'create' ? config.widget.id : '';
    const payload = createPayload(config);
    const reqType = targetWorkbookId ? 'update' : 'create';
    setIsLoading(true);

    if (reqType === 'update') {
      // Update existing workbook
      request = api.updateRecord(targetWorkbookId, payload);
    } else {
      // Create a new workbook associated with widget
      request = api.createRecord(payload, widgetId);
    }

    let updatedWorkbookDoc;

    try {
      updatedWorkbookDoc = await request;
    } catch (err) {
      if (err instanceof BadRequestApiError) {
        throw errorsUtil.createBadWorkbookSaveReqError(`${PREFIX} ${reqType}:`, err);
      } else if (err instanceof UnauthorizedApiError) {
        throw errorsUtil.createUnauthWorkbookSaveReqError(`${PREFIX} ${reqType}:`, err);
      } else if (err instanceof NotFoundApiError) {
        throw errorsUtil.createNotFoundhWorkbookSaveReqError(`${PREFIX} ${reqType}:`, err);
      } else {
        throw errorsUtil.createUnknownWorkbookSaveReqError(`${PREFIX} ${reqType}:`, err);
      }
    } finally {
      setIsLoading(false);
    } // Update workbook ID, necessary
    // for new workbook creation


    if (updatedWorkbookDoc.id && workbookId !== updatedWorkbookDoc.id) {
      setWorkbookId(updatedWorkbookDoc.id);
    } // Reset source state of workbook data
    // for comparisions with updated states


    setOriginWorkbook(payload.workbook);
    setOriginWorkbookMeta(payload.meta);
    setOriginWorkbookFileOrigin({
      origin: payload.origin || '',
      originFileType: payload.originFileType || '',
      originFileId: payload.originFileId || '',
      originUserId: payload.originUserId || ''
    });
    setWorkbookUpdatedAt(updatedWorkbookDoc.updatedAt);
    return updatedWorkbookDoc;
  }; // Request file from Google Drive as Blob


  const getGoogleDriveFile = useCallback(async (fileId, fileName, fileMimeType, accessToken) => {
    setIsLoading(true);

    try {
      return await getFileRequest({
        fileId,
        fileMimeType,
        accessToken: accessToken || ''
      });
    } catch (err) {
      throw errorsUtil.createGetFromDriveFileError(`${PREFIX} getGoogleDriveFile: load file error:`, err, fileName);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading]); //
  // Workbook Syncing Requests
  //

  const subscribe = useCallback(() => subscribeFileRequest({
    workbookId
  }), [workbookId]);
  const unsubscribe = useCallback(() => unSubscribeFileRequest({
    workbookId
  }), [workbookId]);
  return {
    name,
    workbook,
    workbookMeta,
    fileOrigin,
    workbookId,
    sheetNames,
    activeSpreadsheet,
    activeSheetGrid,
    errors,
    isLoading,
    hasUpdates,
    hasWorkbookUpdates,
    hasWorkbookMetaUpdates,
    isWidgetWorkbookUpToDate,
    replace,
    upload,
    save,
    localSave,
    selectSpreadsheet,
    getGoogleDriveFile,
    subscribe,
    unsubscribe
  };
}); // Encode all formats within a workbook for storage

function encodeWorkbookFormats(formats) {
  return formats.map(formatting => {
    return Object.entries(formatting).reduce((acc, _ref2) => {
      let [cellRef, format] = _ref2;
      acc[cellRef] = encodeSSFArgument(format);
      return acc;
    }, {});
  });
} // Convert state into a publishable API payload


function createPayload(config) {
  const clone = cloneDeep({
    name: config.name,
    workbook: config.workbook,
    meta: {
      formats: config.workbookMeta.formats,
      sheetNames: config.workbookMeta.sheetNames,
      grids: config.workbookMeta.grids || [],
      styles: config.workbookMeta.styles || {},
      cellData: config.workbookMeta.cellData || []
    }
  }); // Remove falsey formats that only take up
  // space and will result in a bad request
  // response from servier

  if (clone.meta.formats) {
    clone.meta.formats.forEach(formats => deleteNotTruthey(formats));
  }

  if (clone.meta.grids.length === 0) {
    // @ts-ignore
    delete clone.meta.grids;
  }

  if (config.workbookFileOrigin) {
    const {
      origin,
      originFileType,
      originFileId,
      originUserId
    } = config.workbookFileOrigin; // @ts-ignore

    if (origin || origin === null) clone.origin = origin;
    if (originFileType || originFileType === null) // @ts-ignore
      clone.originFileType = originFileType;
    if (originFileId || originFileId === null) // @ts-ignore
      clone.originFileId = originFileId;
    if (originUserId || originUserId === null) // @ts-ignore
      clone.originUserId = originUserId;
  }

  return clone;
}